import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useAppStore } from "../../../hooks/useStores";
import { PlaygroundImage } from "../../../models/playground";
import { ILabResultGroup } from "../../Playground/store/playground-store";
import { PlaygroundVideoProps } from "../../Playground/VideoGeneration/Video/PlaygroundVideo";
import Experiment from "./Experiment";
import styles from "./LabExperiments.module.scss";

type Props = {
	activeGroupId?: string;
	onJumpTo: (resultId: string, selectedImage: PlaygroundImage | PlaygroundVideoProps) => void;
};

const LabExperiments = observer(({ activeGroupId, onJumpTo }: Props) => {
	const { playgroundStore } = useAppStore();
	const labGroups: ILabResultGroup[] = [...playgroundStore.labResultGroups].reverse();

	return (
		<Box className={styles.container}>
			<Typography className={styles.title}>Experiments</Typography>

			<Box className={styles.imagesContainer}>
				{labGroups.map((group) => (
					<Experiment
						key={group.id}
						group={group}
						isActive={group.id === activeGroupId}
						onClick={() => onJumpTo(group.id, group.selectedImage)}
					/>
				))}
			</Box>
		</Box>
	);
});

export default LabExperiments;
